import { render, staticRenderFns } from "./CustomRusica1A4Type3.vue?vue&type=template&id=5727c9c6&"
import script from "./CustomRusica1A4Type3.vue?vue&type=script&lang=js&"
export * from "./CustomRusica1A4Type3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports